import t from"@mui/material/Tab";import{styled as o}from"@mui/material/styles";const e=o(t)((({theme:t})=>({fontWeight:t.typography.h5.fontWeight,color:t.palette.black60.main})));export{e as Tab};
//# sourceMappingURL=styles.js.map
